// src/App.jsx
import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppProvider } from "./context/AppContext";

// Layout
import BottomNav from "./components/layout/BottomNav";

// Pages
import Home from "./pages/Home";
import Credit from "./pages/Credit";
import Transfer from "./pages/Transfer";
import Confirm from "./pages/Confirm";
import Success from "./pages/Success";
import History from "./pages/History";
import Profile from "./pages/Profile";
import Support from "./pages/Support";

const queryClient = new QueryClient();

const BOTTOM_NAV_ROUTES = ["/", "/history", "/support", "/profile"];

function AppInner() {
  const { pathname } = useLocation();
  const showNav = BOTTOM_NAV_ROUTES.includes(pathname);

  return (
    /*
     * h-[100dvh] = dynamic viewport height — s'adapte à la barre d'adresse
     * du navigateur mobile (contrairement à h-screen / 100vh qui l'ignore).
     */
    <div className="flex flex-col w-full h-[100dvh] bg-[#f0f2f7] overflow-hidden">
      <div className="flex-1 overflow-y-auto overflow-x-hidden hide-scrollbar">
        <Routes>
          <Route path="/"         element={<Home />} />
          <Route path="/credit"   element={<Credit />} />
          <Route path="/transfer" element={<Transfer />} />
          <Route path="/confirm"  element={<Confirm />} />
          <Route path="/success"  element={<Success />} />
          <Route path="/history"  element={<History />} />
          <Route path="/profile"  element={<Profile />} />
          <Route path="/support"  element={<Support />} />
        </Routes>
      </div>

      {showNav && <BottomNav />}
    </div>
  );
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <BrowserRouter>
          <AppInner />
        </BrowserRouter>
      </AppProvider>
    </QueryClientProvider>
  );
}